import { Component, OnInit, ViewChild, Output, EventEmitter, } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';
import { ModuleService } from 'src/app/shared/services/module.service';
import { AppSettings } from '../../../app.constant';

@Component({
  selector: 'app-module-table',
  templateUrl: './module-table.component.html',
  styleUrls: ['./module-table.component.css']
})

export class ModuleTableComponent implements OnInit {
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  displayedColumns: string[] = ['ModuleCode', 'ModuleName', 'Edit'];
  progressBar: boolean = true;
  public resultdata: any;
  post: any;
  errorMessage: any;
  Module: any;
  status: any;
  dataSource: any;
  durationInSeconds = 2;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _moduleService: ModuleService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog, ) { }

  ngOnInit() {
    this._moduleService.refreshNeeded$
      .subscribe(() => {
        this.getAllModule();
      })
    this.getAllModule();
  }

  private getAllModule() {
    this._moduleService.getAllModule(AppSettings.API_ENDPOINT + AppSettings.GetAllModule)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }
        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onEditModule(param: any): void {
    var o = { PK_ModuleID: param.PK_ModuleID }
    this.post = JSON.stringify(o);
    this._moduleService.getModuleByID(AppSettings.API_ENDPOINT + AppSettings.GetModuleByID, this.post).subscribe(
      data => {
        this.Module = data;
        this.messageEvent.emit(this.Module);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteModule(param: any): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Program",
      data: param.ModuleName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        var o = { PK_ModuleID: param.PK_ModuleID }
        this.post = JSON.stringify(o);
        this._moduleService.deleteModuleByID(AppSettings.API_ENDPOINT + AppSettings.DeleteModule, this.post).subscribe(
          data => {
            this.Module = data;
            this.openSnackBar(this.Module, '');
          },
          error => this.errorMessage = <any>error)
      }
    });


  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }

}

